import ProgrammaticDialog from 'js/utils/ProgrammaticDialog';

/**
 * Creates a Conversion Modal to be displayed after the specified delay.
 */
export default class ModalConversion {
  /**
   * Start the component.
   */
  constructor({ element, children, options }) {
    this.element = element;
    this.children = children;
    this.options = options;

    const { content } = this.children;

    if (null !== content) {
      this.setup();
    }
  }

  /**
   * Sets up the modal and timing delay.
   */
  setup = () => {
    this.dialog = new ProgrammaticDialog(this.element);
    document.body.addEventListener('keydown', this.dialog.handleKeydownEsc);

    const delay = Number(this.element.dataset.delay) || 5;

    window.setTimeout(this.initModal, delay * 1000);
  }

  /**
   * Shows the modal after the specified delay.
   */
  initModal = () => {
    const { activeElement } = document;
    this.dialog.show();

    // Set up the close button.
    this.children.close.addEventListener('click', () => {
      this.dialog.hide();
      // Return focus to the previously-active element.
      activeElement.focus();
    });
  }
}
